<template>
  <page-view :key="$route.hash" :title="$t('videos.title')" backLink="/dashboard" backText="Back to Dashboard">
    <template v-slot:header-right>
      <UploadVideo @cancel="uploadNewVideo = false" @open="uploadNewVideo = true" :showForm="uploadNewVideo" />
    </template>
    <template v-if="state === ''">
      <table-list>
        <tr class="header">
          <th class="w-100p w-md-60p">Video</th>
          <th class="w-20p ta-c only-desktop">Uploaded</th>
          <th class="w-10p ta-c only-desktop">Status</th>
          <th class="w-10p extra-padding"></th>
        </tr>
        <a :href="`/video/${video.id}`" @click.prevent="handleLink($event, `/video/${video.id}`)" v-for="(video, index) in videos" :key="index">
          <td class="strong ellipsis">
            <div class="blue">
              <p class="d-i">{{ video.metadata.title }}</p>
            </div>
            <div class="only-mobile">
              <div class="d-f ai-c gray p-t-1">
                <div class="only-mobile video-state gray d-if ai-c m-r-2" v-html="$options.filters.encodingState(video, true)"></div>
                <div class="video-clock d-f ai-c">
                  <i class="icon-clock-fill-24 m-r-1" /> <span class="tt-c">{{ video.created_at | formatdate }}</span>
                </div>
              </div>
            </div>
          </td>
          <td class="ta-c only-desktop">{{ video.created_at | formatdate }}</td>
          <td class="ta-c only-desktop video-state" v-html="$options.filters.encodingState(video)"></td>
          <td class="extra-padding blue"><i class="arrow mdi mdi-chevron-right"></i></td>
        </a>
      </table-list>
      <pagination class="m-t-4 m-b-2" :page="current_page" :maxPage="max_page" @page="paginate" />
    </template>
    <template v-else-if="state === 'loading'">
    </template>
  </page-view>
</template>

<script>

import TableList from '@/components/Lists/Table.vue';
import Pagination from '@/components/Lists/Pagination.vue';
import UploadVideo from '@/components/video/upload-video.vue';

export default {
  components: {
    TableList,
    Pagination,
    UploadVideo,
  },
  computed: {
    uploadingKey() {
      return this.$store.getters['Upload/key'];
    },
  },
  methods: {
    /**
     * Get a list of videos based on parameters
     * @returns {Void}
     */
    async getVideos() {
      const { videos, pagination } = await this.$store.dispatch('Videos/getVideos', {
        page: this.current_page,
        sort: this.sort,
        direction: this.direction,
        per_page: this.per_page,
        skipConf: true,
        skipState: true,
      });

      this.videos = videos;
      this.max_page = pagination.max_page;
      this.current_page = pagination.current_page;
    },
    /**
     * Paginate in video list
     * @param {Number} page
     * @returns {Void}
     */
    paginate(page) {
      this.current_page = page;

      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page,
        },
      });

      this.getVideos();
    },
  },
  watch: {
    uploadingKey() {
      this.getVideos();
    },
  },
  data() {
    return {
      sort: 'scheduled_start_time',
      currentpage: 1,
      direction: 'desc',
      max_page: 1,
      per_page: 15,
      state: 'loading',
      videos: [],
      uploadNewVideo: false,
      videoInterval: null,
    };
  },
  async mounted() {
    const {
      page = 1,
      sort = 'created',
      direction = 'desc',
    } = this.$queryHelper.get({ validSort: ['created'] });

    this.current_page = page;
    this.sort = sort;
    this.direction = direction;

    await this.getVideos();

    this.videoInterval = setInterval(() => {
      this.getVideos();
    }, 15000);

    this.state = '';
  },
  filters: {
    /**
     * Take a video and extract information about its encoding state
     * and return a message
     * @param {Object} video
     * @returns {String}
     */
    encodingState(video, skipColumn = false) {
      const {
        status: {
          life_cycle_status,
          life_cycle_status_message,
        },
        encoding,
      } = video;

      if (life_cycle_status === 'uploading' || life_cycle_status === 'uploadingComplete' || life_cycle_status === 'encoding' || (encoding && encoding.length > 0 && encoding[0].state === 'pending')) {
        return `
          <div class="loading-spinner small inline"></div>
        `;
      }

      if (life_cycle_status === 'complete') {
        return `<div class="d-f ${skipColumn ? '' : 'fd-c'} ai-c jc-c text-green">
          <i class="icon-checkbox-thin"></i>
        </div>`;
      }

      if (life_cycle_status === 'error') {
        return `<div class="d-f ${skipColumn ? '' : 'fd-c'} ai-c jc-c text-red">
          <i class="icon-close-large"></i>
          <span class="p-l-1">${life_cycle_status_message}</span>
        </div>`;
      }

      return '';
    },
  },
  beforeDestroy() {
    clearInterval(this.videoInterval);
  },
};
</script>

<style lang="scss">
.video-state {
  i {
    line-height: 0;
    font-size: 16px;
  }
  span {
    font-size: 12px;
  }
}

.video-clock {
  i {
    line-height: 0;
    font-size: 16px;
  }
}
</style>
